import type { JSX } from 'react';

import { useLocation } from 'react-router';

import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/core/react/router';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { UPLOAD_ERROR_MESSAGES } from 'src/app/shared/hooks/uppyUploader';

import type { PetitionUpdateError } from '../../types';

type Props = {
	errorType: PetitionUpdateError['type'];
};

export function ErrorMessage({ errorType }: Props): JSX.Element {
	const { pathname, search } = useLocation();

	function Message(): JSX.Element {
		if (errorType === 'UNAUTHORIZED') {
			return (
				<TranslateHtml
					value="corgi.petition_update.error.expired_session"
					replacements={{
						loginLink: (
							<Link
								to={`/login_or_join/redirected?redirectTo=${encodeURIComponent(pathname + search)}`}
								data-testid="expired-session-log-in"
								data-qa="expired-session-log-in"
							>
								<Translate value="corgi.petition_update.error.expired_session_log_in" />
							</Link>
						),
					}}
				/>
			);
		}
		return <Translate value={UPLOAD_ERROR_MESSAGES.UNKNOWN_ERROR} />;
	}

	return (
		<InlineMessage variant="error" size="small" role="alert" mb={16}>
			<Message />
		</InlineMessage>
	);
}
